<template>
  <div id="product-card">
    <ul class="card-list">
      <li
        @click="handleItemClick(item)"
        v-for="item of list"
        :key="item.id"
        class="item"
      >
        <h3 class="title">{{ item.name }}</h3>
      </li>
    </ul>
    <div class="ask">
      <button class="ask-btn">立即咨询</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductCard",
  components: {},
  data() {
    return {
      list: [
        { id: 1, name: "百安卡" },
        { id: 2, name: "千福卡" },
        { id: 3, name: "万寿卡" }
      ]
    };
  },
  mounted() {},
  methods: {
    handleItemClick(item) {
      console.log(item);
    }
  }
};
</script>

<style lang="scss" scoped>
#product-card {
  margin-top: 50px;
  overflow: hidden;
  .card-list {
    display: flex;
    margin: 5px 10px;
    .item {
      flex: 1;
      height: 420px;
      margin-right: 44px;
      box-shadow: 0 7px 15px 1px rgba(168, 216, 255, 0.25);
      border-radius: 10px;
      &:last-child {
        margin-right: 0;
      }
      .title {
        font-size: 24px;
        font-weight: 500;
        text-align: center;
        color: #e79b22;
        line-height: 420px;
      }
    }
  }
  .ask {
    width: 100%;
    .ask-btn {
      display: block;
      height: 50px;
      width: 210px;
      margin: 50px auto 0;
      background: #3496e3;
      font-size: 22px;
      color: #ffffff;
      border-radius: 6px;
    }
  }
}
</style>
